import {Routes} from '@angular/router';
import {HomeComponent} from './core/pages/home/home.component';
import {NotFoundComponent} from './core/pages/not-found/not-found.component';
import {PrivacyPolicyComponent} from './core/pages/privacy-policy/privacy-policy.component';
import {TermsOfUseComponent} from './core/pages/terms-of-use/terms-of-use.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/inicio',
        pathMatch: 'full',
    },
    {
        path: 'inicio',
        component: HomeComponent,
    },
    {
        path: 'politica-de-privacidade',
        component: PrivacyPolicyComponent,
    },
    {
        path: 'termo-de-uso',
        component: TermsOfUseComponent,
    },
    {
        path: 'faq',
        loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule),
    },
    {
        path: '**',
        component: NotFoundComponent,
    },
];
